import { render, staticRenderFns } from "./SideBarWalone.vue?vue&type=template&id=32167ac9&scoped=true"
import script from "./SideBarWalone.vue?vue&type=script&lang=js"
export * from "./SideBarWalone.vue?vue&type=script&lang=js"
import style0 from "./SideBarWalone.vue?vue&type=style&index=0&id=32167ac9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32167ac9",
  null
  
)

export default component.exports